import { healthResponseSchema } from '@acasa/shared'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api'

/**
 * Reference query — shows the wiring end to end: shared zod schema, typed
 * fetch wrapper, react-query cache. Copy this shape for real endpoints.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => apiFetch('/health', healthResponseSchema),
    refetchInterval: 15_000,
  })
}
